declare var LOADMANAGERURL: string;
declare var LEAFLETMAPURL: string;

declare interface Window {
    //@ts-ignore
    intlTelInput: (input: any, options?: any) => any;
}

module BookPrenotation {
    interface IBookPrenotationScope extends IBookScope, IModalScope {
        searchHub: (item: CustomerPlant, model: string, label: string, event: any) => void;
        next: (plant_id: number) => void;
        emailValid: boolean;
        render_osm: {
            lat: number;
            lng: number;
            zoom: number;
        };
        defaults_osm: {};
        markers_osm: any[];
        locateMap: () => void;
        sendSms: () => void;
        states: any[];
        selected: any;
        bounds: any;
        //linkId: number;
    }

    class BookPrenotationController extends LM.BookingBase<IBookPrenotationScope> {
        private startLat = 41.895360;
        private startLng = 12.498353;
        private accurancy = 0.01;

        constructor($scope: IBookPrenotationScope, $http: ng.IHttpService, WizardHandler: any, $uibmodal: IModalService, FileUploader: any, private $location: ng.ILocationService, genericHelper: LM.GenericHelperService, $q: ng.IQService, private leafletBoundsHelpers: any) {
            super($scope, genericHelper, $uibmodal, WizardHandler, FileUploader, $http);

            $scope.defaults_osm = {
                tileLayer: LEAFLETMAPURL,
                zoomControlPosition: 'topright',
                tileLayerOptions: {
                    opacity: 0.9,
                    detectRetina: true,
                    reuseTiles: true,
                },
                scrollWheelZoom: true,
            };

            //Init map bounds
            try { this.locateMap(this.startLat, this.startLng, 2); } catch { }

            $scope.markers_osm = new Array();
            const hash = $location.hash();
            let append = '';
            if (/^[A-Za-z0-9=_!]+-[A-Za-z0-9=_!]+$/.test(hash)) {
                append = '/' + hash;
                genericHelper.APIGet<CustomPrivacy>("Booking/GetCustomPrivacy" + append, { apiBaseUrl: APIURL, withAuthentication: false })
                    //$http.get<CustomPrivacy>('/Booking/Book/GetCustomPrivacy' + append)
                    .then(resp => {

                        $scope.customPrivacy = !resp.data ? null : {
                            privacyIt: resp.data.privacyIt,
                            privacyEn: resp.data.privacyEn,
                            privacyLinkIt: resp.data.privacyLinkIt,
                            privacyLinkEn: resp.data.privacyLinkEn,
                            cookieIt: resp.data.cookieIt,
                            cookieEn: resp.data.cookieEn,
                            cookieLinkIt: resp.data.cookieLinkIt,
                            cookieLinkEn: resp.data.cookieLinkEn
                        };

                        $scope.is_privacy_checked();
                    });
            }
            else {
                $scope.is_privacy_checked();
            }

            $http.get<{ plants: CustomerPlant[]; icon: string; color: string }>('/Booking/Book/GetAllPlants' + append).then(resp => {
                if (resp.status == 210 && resp.headers("Redirect") != null) {
                    console.log(JSON.stringify(resp));
                    location.href = resp.headers("Redirect");
                    return;
                }

                //console.log(resp);
                //console.log(JSON.stringify(resp));
                //debugger;

                if (resp.data.color)
                    /*$('.navbar-primary, #navbar-collapse-2').css('background-color', resp.data.color);*/
                    $('.navbar-primary').css('background-color', resp.data.color);
                if (resp.data.icon) {
                    $('#logo').attr('src', resp.data.icon);
                    $('#logo').parent().click(e => e.preventDefault());
                    $('#hamburger-icon').css('color', checkHeaderColor(resp.data.color));
                    //Da richiesta di Pasquale non è necessario stampare logo del cliente in ticket
                    //$scope.linkId = hash.split('-')[1];
                    //$('#print-logo').attr('src', resp.data.icon).css('width','90px');
                }
                let minLat: number;
                let maxLat: number;
                let minLng: number;
                let maxLng: number;
                resp.data.plants.forEach(cp => {
                    this.$scope.docks.push({
                        ...cp,
                        PlantCode: ''
                    });
                    minLat = minLat > cp.Lat || !minLat ? cp.Lat : minLat;
                    maxLat = maxLat < cp.Lat || !maxLat ? cp.Lat : maxLat;
                    minLng = minLng > cp.Lng || !minLng ? cp.Lng : minLng;
                    maxLng = maxLng < cp.Lng || !maxLng ? cp.Lng : maxLng;
                    $scope.markers_osm.push({
                        group: 'plants',
                        lat: cp.Lat,
                        lng: cp.Lng,
                        getMessageScope: () => $scope,
                        message: '<div><h4><b>' + cp.Description + '</b></h4><br/>' + cp.Address + '<br/>' + cp.CAP + '<br/>' + cp.City + '<br/><button class="btn btn-primary" ng-click="next(' + cp.Id + ')">Select</button></div>',
                        icon: {
                            iconUrl: '../../Content/Icons/hub.png'
                        }
                    });
                });
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(loc => {
                        try {
                            if (localStorage.plantLat != null)
                                try { this.locateMap(); } catch { }
                            else if (resp.data.color || resp.data.icon) {
                                $scope.bounds = leafletBoundsHelpers.createBoundsFromArray([
                                    [maxLat, maxLng],
                                    [minLat, minLng]
                                ]);
                            }
                            else {
                                try { this.locateMap(loc.coords.latitude, loc.coords.longitude); } catch { }
                            }
                        } catch { }
                    });
                } else {
                    alert('Geolocalization is not supported by your browser');
                }
            });
            //}, error => {
            //    console.log(JSON.stringify(error.headers("Redirect")));
            //    location.href = "https://acmei.loadmanager.cloud";
            //});

            $scope.emailRegex = genericHelper.emailRegex;
            $scope.allowPdfDownload = false;
            $scope.canSave = false;
            $scope.privacyStatement = '';

            $scope.hubSR = genericHelper.createSignalRHub();

            $scope.next = (plant_id: number) => {
                let plant = $scope.docks.find(dock => dock.Id == plant_id);
                if (plant) {
                    $scope.hub_id = plant_id;
                    try {
                        localStorage.plantLat = plant.Lat;
                        localStorage.plantLng = plant.Lng;
                    } catch { }
                    $scope.plantCode = plant.ExternalCode;

                    $('#plantCity').text(plant.City + ': ' + plant.Description);
                    this.GetD(plant_id).then(() => {
                        this.findTimeAfterFreeze(plant_id);
                        $scope.initialDateTime = moment($scope.data.selecteddate).add($scope.data.selectedtime, "h");
                        $http.get<WfMandatoryField[]>('/booking/book/GetMandatoryFields?PlantCode=' + $scope.plantCode + '&CustId=' + $scope.customerCode).then(res => {
                            $scope.mandatoryFieldsList = res.data;
                        });
                        $http.get<BookingFieldLabelsGet>('/booking/book/GetBookingFieldLabels?PlantCode=' + $scope.plantCode + '&CustId=' + $scope.customerCode).then(res => {
                            $scope.bookingFieldLabels = res.data;
                        });
                        WizardHandler.wizard().next();
                    });
                }

            };

            $scope.searchHub = (item: CustomerPlant, model: string, label: string, event: any) => {
                if (item) {
                    try { this.locateMap(item.Lat, item.Lng); } catch { }
                }
            };

            $scope.$watch((a: IBookScope) => a.data.selecteddate, (newValue?: string) => { //YYYY/MM/DD
                const plant = $scope.docks.find(d => d.Id == $scope.hub_id);
                const now = moment.tz(this.TZ);
                const parsed = moment.tz(newValue, "YYYY/MM/DD", this.TZ);
                let selected = newValue ? parsed : now;
                if (selected.isSame(now, 'day'))
                    selected = now.clone().startOf('day');

                if ($scope.minValidDate && $scope.minValidDate.isSame(parsed, 'date'))
                    this.findTimeAfterFreeze(plant.Id)
                else {
                    if (plant && !$scope.selectedWD)
                        $http.get<LM.IGetWorkingTime>(`/Book/GetWorkingTime?plantId=${plant.Id}&date=${selected.toISOString()}`).then(res => {
                            if (moment.tz(res.data.openingHour, this.TZ) > now.clone().add(this.$scope.freezeBooking, 'h')) {
                                this.$scope.selectedWD.Opening = (moment.tz(res.data.openingHour, this.TZ)).tz(this.TZ).clone();
                                this.$scope.selectedWD.Closing = moment.tz(res.data.closingHour, this.TZ);
                                this.$scope.data.selectedtime = (moment.tz(res.data.openingHour, this.TZ)).tz(this.TZ).clone().hours();
                            }
                            else {
                                this.$scope.selectedWD.Opening = now.clone().add(this.$scope.freezeBooking, 'h');
                                this.$scope.selectedWD.Closing = moment.tz(res.data.closingHour, this.TZ);
                                this.$scope.data.selectedtime = now.clone().add(this.$scope.freezeBooking, 'h').hours();
                            }

                            $scope.$evalAsync();
                            $scope.docksLimit = res.data.maxDocks;
                        });
                    else if (newValue)

                        $http.get<LM.IGetWorkingTime>(`/Book/GetWorkingTime?plantId=${plant.Id}&date=${selected.toISOString()}`).then(res => {

                            if (moment.tz(res.data.openingHour, this.TZ) > now.clone().add(this.$scope.freezeBooking, 'h')) {
                                this.$scope.selectedWD.Opening = (moment.tz(res.data.openingHour, this.TZ)).tz(this.TZ).clone();
                                this.$scope.selectedWD.Closing = moment.tz(res.data.closingHour, this.TZ);
                                this.$scope.data.selectedtime = (moment.tz(res.data.openingHour, this.TZ)).tz(this.TZ).clone().hours();
                            }
                            else {
                                this.$scope.selectedWD.Opening = now.clone().add(this.$scope.freezeBooking, 'h');
                                this.$scope.selectedWD.Closing = moment.tz(res.data.closingHour, this.TZ);
                                this.$scope.data.selectedtime = now.clone().add(this.$scope.freezeBooking, 'h').hours();
                            }
                            $scope.$evalAsync();
                            $scope.docksLimit = res.data.maxDocks;
                        });
                }
            });
        }
        /**
         * Function to center map
         * @param lat
         * @param lng
         * @param accurancy
         */
        private locateMap(lat: number = parseFloat(localStorage.plantLat), lng: number = parseFloat(localStorage.plantLng), accurancy: number = this.accurancy) {
            this.$scope.bounds = this.leafletBoundsHelpers.createBoundsFromArray([
                [lat + accurancy, lng + accurancy],
                [lat - accurancy, lng - accurancy]
            ]);
        }

        private handleTileError($event: any) {
            if ($event.tile._hasError) return;

            var url = "http://tile.osm.org/{z}/{x}/{y}.png"
            var tileSrc = url.replace(/{x}/g, $event.coords.x);
            tileSrc = tileSrc.replace(/{y}/g, $event.coords.y);
            tileSrc = tileSrc.replace(/{z}/g, $event.coords.z);
            $event.tile._hasError = true;
            $event.tile.src = tileSrc;
        }
    }

    globalApp.requires.push('mgo-angular-wizard',
        'ui.select',
        'vcRecaptcha',
        'ui.bootstrap',
        'angularFileUpload',
        'leaflet-directive',
        'ngfallbackSrc');

    globalApp.config(["$logProvider",
        function ($logProvider: any) {
            $logProvider.debugEnabled(false);
        }]);

    globalApp
        .config(['uiSelectConfig', (uiSelectConfig: any) => uiSelectConfig.theme = 'bootstrap'])
        .controller('BookPrenotationCtrl', [
            '$scope',
            '$http',
            'WizardHandler',
            '$uibModal',
            'FileUploader',
            '$location',
            'genericHelper',
            '$q',
            'leafletBoundsHelpers',
            BookPrenotationController
        ]);
}
